import DatePicker from "react-datepicker";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { components } from "react-select";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { CalenderIcon } from "../../Icon";
import { CircularAvatar } from "../../commons";
import { reverseDate } from "../../../utils/commonFunctions";

type DropDown = { label: string; value: null | number };

type AppProps = {
  setShowSendCheckInRequestModal: any;
  finalManagerList: any;
  setManagerOffset: React.Dispatch<React.SetStateAction<number>>;
  addCheckInScheduleData: (data: any) => void;
  updateCheckInScheduleData: (data: any) => void;
  setManagerText: React.Dispatch<React.SetStateAction<string>>;
  dispatchResetSingleDetails: () => void;
  managerLimit: number;
  isEdit?: boolean;
  singleCheckInScheduleDetails: any;
  selectedManager: DropDown;
  setSelectedManager: React.Dispatch<React.SetStateAction<DropDown>>;
  scheduleTimeAndTate: string;
  managersAvailableCheckInScheduleSlots: any;
  setScheduleTimeAndTate: React.Dispatch<React.SetStateAction<string>>;
};

const SendCheckInModal = ({
  setShowSendCheckInRequestModal,
  finalManagerList,
  setManagerOffset,
  managerLimit,
  addCheckInScheduleData,
  setManagerText,
  singleCheckInScheduleDetails,
  updateCheckInScheduleData,
  isEdit,
  dispatchResetSingleDetails,
  selectedManager,
  setSelectedManager,
  scheduleTimeAndTate,
  setScheduleTimeAndTate,
  managersAvailableCheckInScheduleSlots,
}: AppProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const isEmptyObject = () => {
    return (
      Object.keys(singleCheckInScheduleDetails).length === 0 &&
      singleCheckInScheduleDetails.constructor === Object
    );
  };
  useEffect(() => {
    if (singleCheckInScheduleDetails) {
      singleCheckInScheduleDetails?.date &&
        singleCheckInScheduleDetails?.start_time &&
        setScheduleTimeAndTate(
          `${reverseDate(singleCheckInScheduleDetails?.date)}, ${
            singleCheckInScheduleDetails?.start_time
          }`
        );

      setSelectedManager({
        value: singleCheckInScheduleDetails?.manager?.user_id
          ? singleCheckInScheduleDetails?.manager?.user_id
          : null,
        label: singleCheckInScheduleDetails?.manager?.first_name
          ? `${singleCheckInScheduleDetails?.manager?.first_name} ${
              singleCheckInScheduleDetails?.manager?.last_name
                ? singleCheckInScheduleDetails?.manager?.last_name
                : ""
            }`
          : "Select..",
      });
    }
    if (isEmptyObject()) {
      setScheduleTimeAndTate("");
      setSelectedManager({
        label: "Select...",
        value: null,
      });
    }
  }, [singleCheckInScheduleDetails]);

  const toggle = () => {
    setIsOpen(!isOpen);
    setShowSendCheckInRequestModal((prev: boolean) => !prev);
  };

  const handleManagerDropdownChange = (data: DropDown) => {
    setSelectedManager({
      value: data.value,
      label: data?.label?.split("%")[0],
    });
  };

  const handleTimeAndDateChange = (date: any) => {
    setScheduleTimeAndTate(date === "Invalid date" ? null : date);
  };

  const checkBottom = () => {
    setManagerOffset((prev: any) => prev + managerLimit);
  };
  const handleAddCheckInSchedule = () => {
    const finalData = {
      manager: selectedManager?.value,
      date: scheduleTimeAndTate?.split(",")[0],
      startTime: scheduleTimeAndTate?.split(",")[1],
      checkInId: singleCheckInScheduleDetails?._id
        ? singleCheckInScheduleDetails?._id
        : "",
    };
    if (isEdit) {
      updateCheckInScheduleData(finalData);
    } else {
      addCheckInScheduleData(finalData);
    }
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  // Function to check if a given time falls within the disabled time slots
  const isTimeDisabled = (
    time: string,
    managersAvailableCheckInScheduleSlots: any
  ) => {
    const formattedDate = moment(time).format("DD-MM-YYYY");
    const formattedTime = moment(time).format("HH:mm");

    return managersAvailableCheckInScheduleSlots.some((slot: any) => {
      if (slot.date === formattedDate) {
        const slotStartTime = moment(
          `${slot.date} ${slot.start_time}`,
          "DD-MM-YYYY HH:mm"
        ).format("HH:mm");
        return slotStartTime === formattedTime;
      }
      return false;
    });
  };

  const filterPassedTime = (time: any) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    // Disable past times and specific disabled slots
    return (
      currentDate.getTime() < selectedDate.getTime() &&
      !isTimeDisabled(time, managersAvailableCheckInScheduleSlots)
    );
  };

  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={() => toggle()}
      backdrop="static"
      style={{ width: "32wh", marginTop: "0px" }}
    >
      <ModalHeader
        className="pt-3 pl-4"
        id="cross-cut"
        toggle={() => {
          toggle();
          dispatchResetSingleDetails();
        }}
        style={{ paddingBottom: "13px" }}
      >
        <span style={{ color: "#262a44", fontSize: "18px", fontWeight: "600" }}>
          {isEdit ? "Update Checkin Request" : "Send Checkin Request"}
        </span>
      </ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <div>
          <span
            style={{ color: "#262a44", fontSize: "15px", fontWeight: "500" }}
          >
            Select manager from dropdown below to schedule check in process
          </span>
          <div className="mt-4" style={{ width: "70%" }}>
            <label className="mb-1">Select Manager</label>
            <Select
              value={selectedManager}
              options={finalManagerList}
              onChange={(e: any) => handleManagerDropdownChange(e)}
              onMenuScrollToBottom={checkBottom}
              components={{ Option }}
              onInputChange={(e: any) => {
                setManagerText?.(e);
              }}
            />
          </div>
          <div className="mt-4 mb-5" style={{ width: "80%" }}>
            <label className="mb-1" htmlFor="checkInDateAndTime">
              Check-In Date and Time
            </label>
            <div className="form-group">
              <div className="date-picker-wraper mr-0 lead-date-picker position-relative">
                <Label className="m-0 p-0 w-100">
                  <DatePicker
                    selected={
                      scheduleTimeAndTate
                        ? new Date(
                            moment(
                              `${scheduleTimeAndTate}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      handleTimeAndDateChange(
                        moment(e).format("YYYY-MM-DD, HH:mm")
                      );
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    name="dateOfInvoice"
                    placeholderText="Choose date"
                    className="form-control"
                    showTimeSelect
                    minDate={new Date()}
                    value={scheduleTimeAndTate}
                    dateFormat="MMMM d, yyyy h:mm"
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    filterTime={filterPassedTime}
                  />
                  <span
                    className="calender-icon mt-3"
                    style={{ top: "-10px", right: "5px", cursor: "pointer" }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter
        style={{ justifyContent: "flex-start", borderTop: "none" }}
        className="pl-4 pr-4 pb-4"
      >
        <div className="d-flex align-items-start">
          <span
            className="pointer btn-outline-dark btn"
            style={{ border: "1px solid #bfcbe1" }}
            onClick={() => {
              toggle();
              dispatchResetSingleDetails();
            }}
          >
            Cancel
          </span>
          <Button
            color="primary ml-3"
            onClick={() => {
              handleAddCheckInSchedule();
              toggle();
              dispatchResetSingleDetails();
            }}
            disabled={!selectedManager?.value || !scheduleTimeAndTate}
          >
            {isEdit ? "Update Schedule Check-In" : "Schedule Check-In"}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default SendCheckInModal;
